import { createContext, useContext } from "react";

/**
 * Context for Coral drawer state and operations
 * Only components that need drawer state will rerender when this changes
 */
export interface CoralDrawerContextType {
  drawerId: string;
  isDrawerOpen: boolean;
  isDrawerTransitionDisabled: boolean;
  isDrawerPrerendered: boolean;
  openDrawer: (options?: { disableTransition?: boolean }) => void;
  closeDrawer: (options?: { disableTransition?: boolean }) => void;
  prerenderDrawer: () => void;
}

const CoralDrawerContext = createContext<CoralDrawerContextType>({
  drawerId: "coral-drawer",
  isDrawerOpen: false,
  isDrawerTransitionDisabled: false,
  isDrawerPrerendered: false,
  openDrawer: () => {},
  closeDrawer: () => {},
  prerenderDrawer: () => {},
});

export const useCoralDrawerContext = () => {
  const context = useContext(CoralDrawerContext);
  return context;
};

export default CoralDrawerContext;
